export const widgetAutoImport = {
    namespaced: true,

    state: {
        autoImportHeaderTitle: ''
    },

    getters: {
        autoImportHeaderTitle(state) {
            return state.autoImportHeaderTitle;
        }
    },

    mutations: {
        setAutoImportHeaderTitle(state, data) {
            state.autoImportHeaderTitle = data;
        }
    }
};

export default widgetAutoImport;
